//This component will confirm payments

const ConfirmSubscriptionComponent = () => {
  return (
    <div>
      <h3>This is the subscription confirm page</h3>
    </div>
  );
};

export default ConfirmSubscriptionComponent;
